import { useDroppable } from "@dnd-kit/core";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { getDraggingClassNames, wrapperClassNames } from "./class-names";
import { droppableSeparatorIdPrefix } from "../constants";

const contentClassNames =
  "absolute w-full h-full flex items-center justify-center pointer-events-none";

const getDroppablePlaceholderClassNames = ({
  isDraggingOver,
}: {
  isDraggingOver?: boolean;
}) => {
  const baseStyles =
    "flex items-center justify-center py-6 border-dashed border border-neutral-200 bg-neutral-20 rounded-[1rem] mb-8";
  const draggingOverStyles =
    "border-blue-560 bg-blue-60 shadow-[0_0_0_4px_rgba(174,211,254,0.6)]";
  const activeStyles =
    "active:border-blue-560 active:shadow-[0_0_0_4px_rgba(174,211,254,0.6)]";

  return clsx(baseStyles, activeStyles, isDraggingOver && draggingOverStyles);
};

export const DroppableSeparator = ({
  index,
  groupUri,
  disabled,
  variant = "field",
}: {
  index: number;
  groupUri?: string | null;
  disabled?: boolean;
  variant?: "field" | "initial-group";
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `${droppableSeparatorIdPrefix}${groupUri ? `|${groupUri}` : ""}|${index}`,
    disabled,
  });

  if (variant === "initial-group") {
    return (
      <div
        ref={setNodeRef}
        className={twMerge(
          getDroppablePlaceholderClassNames({
            isDraggingOver: isOver,
          }),
        )}
      >
        <div className="text-ui px-4 text-neutral-500">
          Drag and drop &apos;Components&apos; here
        </div>
      </div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      className={clsx(
        wrapperClassNames,
        disabled && "transition ease-out duration-200 opacity-0",
      )}
    >
      <div className={contentClassNames}>
        <div
          className={clsx(getDraggingClassNames(isOver, false), "h-[0.8rem]")}
        />
      </div>
      <div className="w-[12.5rem] h-[1.6rem] my-0 mx-auto" />
    </div>
  );
};
